export const defaultValuesPricingSummaryForm = {
  currency: 1,
  irIndex: 78,
  runDate: '',
  frequency: 'Quarterly',
  graphGroups: [],
};
